// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/QuickAccessModal.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/QuickAccessModal.tsx");
  import.meta.hot.lastModified = "1740183864612.8992";
}
// REMIX HMR END

import { useState } from "react";
import clsx from "clsx";
import Default from "@assets/quickAccess/default.svg";
import Hover from "@assets/quickAccess/hover.svg";
import { Popover, Transition } from "@headlessui/react";
import React from "react";
import IconResolver from "./IconResolver";
import Link from "./Link";
import Heading from "./Heading";

/**
 * Renders a floating Doc. Tahedroid icon that shows a modal with ways to contact us when you click it
 * Items are hardcoded for now but they should be passed to this component as props.
 */

export default function QuickAccessModal() {
  _s();
  const [icon, setIcon] = useState(Default);
  const items = [{
    label: "Get in Touch",
    text: "Contact us!",
    icon: "email",
    link: "/get-touch",
    linkText: "Send us a message"
  }, {
    label: "Schedule",
    text: "Let's meet:",
    icon: "calendar",
    link: "https://calendly.com/jmolivas/free-one-to-one-consultation",
    linkText: "Book an online appointment"
  }, {
    label: "Call us",
    text: "We want to hear from you! Tel:",
    icon: "phone",
    link: "tel:760-618-1215",
    linkText: "760-618-1215"
  }, {
    label: "Email",
    text: "Drop us a line:",
    icon: "email",
    link: "mailto:hq@octahedroid.com",
    linkText: "hq@octahedroid.com"
  }];
  return <Popover className={({
    open
  }) => clsx("z-50 fixed md:overflow-y-visible flex flex-col", open ? "inset-0 md:inset-auto md:bottom-4 md:right-4" : "bottom-4 right-4")}>
      {({
      open,
      close
    }) => <>
          <Transition show={open} as={React.Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0 translate-y-1" enterTo="opacity-100 translate-y-0">
            <Popover.Panel className="bg-neutral-100 md:mb-6 rounded h-full flex-1 md:w-[375px]">
              <div className="flex items-center justify-items-end p-6 bg-white">
                <Heading tag="h2">How can we help you?</Heading>
                <div onClick={() => {
              close();
              setIcon(Default);
            }} className="ml-auto text-neutral-500 cursor-pointer">
                  <IconResolver token="x" className="w-6 h-6 hover:text-neutral-400" />
                </div>
              </div>
              <div className="p-6 rounded-b text-neutral-600 md:shadow-[0_4px_20px_rgba(0,0,0,0.25)]">
                <p>
                  We’ll be in touch before you can say “meow” to map out the
                  next steps!
                </p>
                <ul className="text-sm">
                  {items.map(item => <li key={item.label} className="flex flex-col my-4 p-3 bg-neutral-50 hover:bg-neutral-200 text-neutral-300 hover:text-neutral-500">
                      <p className="flex items-center">
                        <IconResolver token={item.icon} className="mr-2 w-6 h-6" />
                        <span className="font-semibold text-xl text-primary-700">
                          {item.label}
                        </span>
                      </p>
                      <div>
                        <span className="text-neutral-600">{item.text} </span>
                        <Link target="_blank" rel="noopener noreferrer" to={item.link} className="underline text-secondary-800">
                          {item.linkText}
                        </Link>
                      </div>
                    </li>)}
                </ul>
              </div>
            </Popover.Panel>
          </Transition>
          <Popover.Button className={clsx("animate-smooth-bounce outline-none ml-auto cursor-pointer", open && "collapse md:visible h-0 md:h-auto")} onClick={() => {
        setIcon(Hover);
      }}>
            <img className={clsx("h-[96px] w-[96px]", open ? "drop-shadow-[0_4px_20px_rgba(0,0,0,0.25)] transform-gpu" : "hover:drop-shadow-[0_4px_20px_rgba(0,0,0,0.25)] transform-gpu")} src={icon} alt="" onMouseEnter={() => setIcon(Hover)} onMouseLeave={() => {
          !open && setIcon(Default);
        }} />
          </Popover.Button>
        </>}
    </Popover>;
}
_s(QuickAccessModal, "jzb4F+NiL/vFkeqmwIGvtztbEMc=");
_c = QuickAccessModal;
var _c;
$RefreshReg$(_c, "QuickAccessModal");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;